export default [
  // {
  //   id: 'profile',
  //   title: '프로필',
  //   previewJumpId: 'preview-page-01'
  // },
  {
    id: 'profile',
    title: '프로필',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'address',
    title: '주소',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'contacts',
    title: '연락처',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'id-photo',
    title: '증명사진',
    previewJumpId: 'close-preview-button-above'
  },
  {
    id: 'job-summary',
    title: '업무요약',
    previewJumpId: 'preview-page-01'
  },
  {
    id: 'skills-to-use',
    title: '스킬',
    // previewJumpId: 'preview-page-02'
    previewJumpId: 'skills'
  },
  {
    id: 'job-history',
    title: '업무경력',
    previewJumpId: 'job-history'
  },
  {
    id: 'pr-message',
    title: '자기PR',
    previewJumpId: 'pr-message'
  },
  {
    id: 'create-date',
    title: '작성일',
    previewJumpId: 'preview-page-01'
  },
  {
    id: 'confirm',
    title: '확인',
    previewJumpId: 'confirm-button'
  },
  {
    id: 'output',
    title: '다운로드',
    previewJumpId: 'preview-page-01'
  }
]
